import { httpV1 as http } from '@/services/api';

const BASE = '/backoffice/access/feature-access';

// Dry-run: valida e retorna o plano (a liberar / já liberado / não encontrado / precisa decisão).
export async function previewFeatureAccess(payload) {
  return http.post(`${BASE}/preview`, payload);
}

// Executa a liberação em massa (idempotente).
export async function grantFeatureAccess(payload) {
  return http.post(`${BASE}/grant`, payload);
}

// Remove (revoga) liberações existentes.
export async function revokeFeatureAccess(payload) {
  return http.post(`${BASE}/revoke`, payload);
}
